class gTagEvents {
    constructor() {
        this.delegateBody = new Delegate(document.body);

        this.initIntersectionObserver();
        this.interceptCartApi();
        this.bindEvents();
        this.observeDOMChanges();
        this.domChanged();
    }

    bindEvents() {
        this.delegateBody.on("filters:sort:changed", () => { this.sendSortByData(); this.sendFiltersData(); });
        this.delegateBody.on("click", '[name="checkout"]', this.handleCheckout.bind(this));
        this.delegateBody.on("filters:cleared", this.clearFiltersData.bind(this));
        this.delegateBody.on("facet:criteria-changed", this.sendSortByData.bind(this));
        this.delegateBody.on("click", '[data-action="ga-send-select"], [data-ga-action="ga-send-select"]', this.handleSelectItem.bind(this));
        this.delegateBody.on("click", ".cartFooter--bottomLink", this.handleCartContinueShopping.bind(this));
    }

    initIntersectionObserver() {
      const settings =  {
        root: null, // Use the viewport as the root
        rootMargin: "0px",
        threshold: 0.1, // Adjust the threshold as per your requirement
      }

      this.intersectionObserver = new IntersectionObserver(this.handleIntersection.bind(this), settings);
    }

    sendSortByData(){
        const isDesktop =  new Responsive().matchesBreakpoint('lap-and-up');
        const oldSortByValue = sessionStorage.getItem("SortByValue");
        const sortBy = isDesktop ? 
            document.querySelector('input[name="sort_by"]:checked') : 
            document.querySelector('#sortby.Drawer--wrapper input[name="sort_by"]:checked');    

        if (!sortBy) return;
        const sortByValue = isDesktop ? 
            sortBy.getAttribute('title').replace(' ', '-') : 
            sortBy.value;

        if (!sortByValue || sortByValue === "" || oldSortByValue === sortByValue) return;
        sessionStorage.setItem("SortByValue", sortByValue);

        const payload = {
            event: "sort_applied",
            sort_by: sortByValue,
        };
        dataLayer.push(payload);
    }

    sendFiltersData() {  
        function arraysEqual(arr1, arr2) {
            if (!arr1 || !arr2) return arr1 === arr2;

            return (
                Array.isArray(arr1) &&
                Array.isArray(arr2) &&
                arr1.length === arr2.length &&
                arr1.every((val, index) => val === arr2[index])
            );
        }

        const filtersList = [];
        let oldFiltersList = sessionStorage.getItem("CollectionsFiltersList");
        const filterCheckboxes = document.querySelectorAll('.inputFilterCheckbox');

        if (oldFiltersList) oldFiltersList = JSON.parse(oldFiltersList);

        filterCheckboxes.forEach(checkbox => {
            if (checkbox.checked) {
                filtersList.push(checkbox.dataset.filterName + ":" + checkbox.value);
            }
        });
        
        if (!filtersList.length || arraysEqual(filtersList, oldFiltersList)) return;

        sessionStorage.setItem("CollectionsFiltersList", JSON.stringify(filtersList));

        const payload = {
            event: "filter_applied",
            filter_by: filtersList,
        };
        dataLayer.push(payload);
    }

    clearFiltersData() {
        // Get the previously stored filters before clearing
        let oldFiltersList = sessionStorage.getItem("CollectionsFiltersList");
        if (oldFiltersList) {
            oldFiltersList = JSON.parse(oldFiltersList);
        } else {
            oldFiltersList = [];
        }
        
        // Clear the stored filters
        sessionStorage.setItem("CollectionsFiltersList", JSON.stringify([]));
        
        const payload = {
            event: "clear_filters",
            filter_by: oldFiltersList,
        };
        dataLayer.push(payload);
    }

    interceptCartApi() {
        const originalFetch = window.fetch;
        const _this = this;

        window.fetch = async function (...args) {
            try {
                const [url, request] = [...args];

                if ((typeof url === 'object' && url !== null) || !(url.includes("/cart") || url.includes(".js"))) {
                  return originalFetch.apply(this, args);
                }

                if (url.includes(`/cart/clear`)) _this.cartClear();
                if (url.includes(`/cart/update`)) _this.cartUpdate(request.body);

                const response = await originalFetch.apply(this, args);
                if (!response.ok) return response;
                if (url === '' || !dataLayer) return response;             

                if (url.includes(`/cart/add`)) {
                    const responseClone = response.clone();
                    const json = await responseClone.json(); 
                    _this.cartAdd(json, request);
                } else if (url.includes(`/cart/change`)) {
                    const responseClone = response.clone();
                    const json = await responseClone.json(); 
                    _this.cartChange(json);
                }

                return response;

            } catch (e) {
                console.error('Fetch interceptor error:', e);
                return originalFetch(...args);
            }
        };
    }

    async getCart() {
        const url = (window.themeVariables && window.themeVariables.routes && window.themeVariables.routes.rootUrlWithoutSlash)
            ? `${window.themeVariables.routes.rootUrlWithoutSlash}/cart.js`
            : `${window.location.origin}/cart.js`;
        const response = await fetch(url);
        if (!response.ok) return { items: [] };
        return response.json();
    }

    async cartAdd(cart, request) {
        let cartItems = cart.items ? cart.items : [cart];
        cartItems = this.getDataFromRequest(cartItems, request);
        this.productAdded(cartItems);
    }

    async cartUpdate(body) {
      if (!body) return;
      
      let parsedBody;
      try {
        parsedBody = JSON.parse(body);
      } catch (e) {
        console.error('[GTag] Error parsing cart update body:', e);
        return;
      }
      
      const updates = parsedBody?.updates;
      if (!updates || typeof updates !== 'object') {
        console.warn('[GTag] No updates object found in cart update body');
        return;
      }
  
      const oldCart = await this.getCart();
      if (!oldCart || !oldCart.items || !Array.isArray(oldCart.items)) {
        console.warn('[GTag] Invalid cart data received');
        return;
      }
      
      const cartItems = oldCart.items;
      let itemsAdded = [], itemsRemoved = [];

      cartItems.forEach(item => {
          if (!item || !item.key) return;
          
          const newQuantity = updates[item.key];
          if (typeof newQuantity === "number") {
              const change = newQuantity - item.quantity;
              item.quantity = Math.abs(change);
              change < 1 ? itemsRemoved.push(item) : itemsAdded.push(item);
          }
      });

      itemsAdded = this.setLocationShoppingCart(itemsAdded);
      itemsRemoved = this.setLocationShoppingCart(itemsRemoved);

      this.productAdded(itemsAdded);
      this.productsRemoved(itemsRemoved);
    }

    async cartChange(cart) {      
      const itemsAdded = this.setLocationShoppingCart(cart.items_added);
      const itemsRemoved = this.setLocationShoppingCart(cart.items_removed);

      this.productAdded(itemsAdded);
      this.productsRemoved(itemsRemoved);
    }

    productAdded(cartItems) {
        if (!cartItems || !cartItems.length) return;

        const ecommerce = this.buildEcommerce(cartItems);

        const customEvent = {
            event: 'custom_add_to_cart',
            ecommerce
        };

        dataLayer.push({ ecommerce: null });
        dataLayer.push(customEvent);

        // Derive collection context from the current URL (only fire on collection pages)
        const collectionContext = this.getCurrentCollectionContext();

        if (collectionContext) {
          const collectionsEvent = {
            event: 'collections_add_to_cart',
            ecommerce,
            collection_handle: collectionContext.handle,
            collection_url: collectionContext.url
          };

          dataLayer.push({ ecommerce: null });
          dataLayer.push(collectionsEvent);
        }
    }

    getCurrentCollectionContext() {
      try {
        const path = window.location.pathname || "";
        const match = path.match(/\/collections\/([^\/\?]+)/);
        if (!match) return null;

        const handle = match[1];
        const base = window.location.origin || "";

        return {
          handle,
          url: `${base}/collections/${handle}`
        };
      } catch (e) {
        console.error("[GTag] Error detecting collection context:", e);
        return null;
      }
    }

    productsRemoved(cartItems) {
      if (!cartItems || !cartItems.length) return;

      const customEvent = {
            'event': "custom_remove_from_cart",
            'ecommerce': this.buildEcommerce(cartItems)
      };

      dataLayer.push({ ecommerce: null });
      dataLayer.push(customEvent);
    }

    buildEcommerce(cartItems) {
        const items = [];
        let totalPrice = 0;        
        const global_item_id = cartItems[0].list_id;
        const global_item_name = cartItems[0].list_name;
        cartItems.forEach((item) => {            
            const price = typeof item.price === "number" ? item.price / 100 : Number(item.price);
            totalPrice += price * item.quantity;
            
            const product = {
                'item_id': item.sku || "",
                'item_name': item.untranslated_product_title || item.title || "",
                'item_variant': item.untranslated_variant_title || "Default Title",
                'price': price, 
                'quantity': item.quantity,
                'category': item["category"] || "",
                'category2': item["category2"] || "",
                'item_brand': item["item_brand"] || item.vendor || "",
                'item_list_id': item["list_id"] || "",
                'item_list_name': item["list_name"] || ""
            };

            items.push(product);
        });

        return {
            'value': totalPrice,
            'currency': ShopifyAnalytics.meta.currency,
            'item_list_id':global_item_id,
            'item_list_name': global_item_name,
            'items': items
        };
    }

    getDataFromRequest(cartItems, request) {
        const body = request?.body || null;
        if (!body) return cartItems;

        const json = body instanceof FormData
            ? Object.fromEntries(body.entries())
            : JSON.parse(body);

        const quantity = json["quantity"] || 1;
        cartItems[0].quantity = Number(quantity);
        
        cartItems[0]["category"] = json["_gtm-category"] || "";
        cartItems[0]["category2"] = json["_gtm-category2"] || "";
        cartItems[0]["item_brand"] = json["_gtm-item_brand"] || "";
        cartItems[0]["list_id"] = json["_gtm-list_id"] || "";
        cartItems[0]["list_name"] = json["_gtm-list_name"] || "";

        return cartItems;
    }

    setLocationShoppingCart(array) {
      return array.map(item => {            
          item["list_id"] = "shopping_cart"
          item["list_name"] = "Shopping cart"

          // Match DOM: Liquid uses item.key for data-gtm-id; cart API uses key
          const lineItemKey = item.key || item.view_key;
          const lineItem = lineItemKey ? document.querySelector(`[data-gtm-id="${lineItemKey}"]`) : null;
          if (lineItem) {
            const category = lineItem.dataset.gtmCategory;
            const category2 = lineItem.dataset.gtmCategory2;
            const brand = lineItem.dataset.gtmItemBrand;
            if (category) item["category"] = category;
            if (category2) item["category2"] = category2;
            if (brand) item["item_brand"] = brand;
          }
          // Fallback: Shopify cart API includes vendor on each item
          if (!item["item_brand"] && item.vendor) item["item_brand"] = item.vendor;

          return item;
      });
    }

    handleCheckout(event) {
        const button = event.target.closest("button[name='checkout']");
        if (!button) return;

        const script = button.parentElement.querySelector('[type="application/ld+json"]');
        const settings = JSON.parse(script.innerText);

        if (!dataLayer || !settings) return;

        dataLayer.push({ ecommerce: null });
        dataLayer.push(settings);

    }

    handleSelectItem(event) {
      let target = event.target.closest('[data-action="ga-send-select"]') || event.target.closest('[data-ga-action="ga-send-select"]');
      if (!target || !dataLayer) return;

      const settings = JSON.parse(target.dataset.selectSettings);
      if (!settings) return;

      const customEvent = { 
          event: "custom_select_item",
          ecommerce: {
              item_list_id: settings.list_id,
              item_list_name: settings.list_name,
              currency: ShopifyAnalytics.meta.currency,
              items: [settings]
          }
      }
  
      dataLayer.push({ ecommerce: null });
      dataLayer.push(customEvent);
  }

    handleCartContinueShopping(event) {
      if (!dataLayer) return;

      const payload = {
        event: "cart_continue_shopping",
        link_url: event.currentTarget?.href || window.location.href
      };

      dataLayer.push(payload);
    }

  domChanged() {
      const allIntersections = document.body.querySelectorAll('[data-gtag-intersection][data-observed="false"]');

      allIntersections.forEach((item) => {
        // Always use intersection observer so events re-fire when element scrolls back into view
        this.intersectionObserver.observe(item);
        item.dataset.observed = "true";
      });
    }
    
    processIntersectionElement(element) {
      const scriptElement = element.querySelector('script[type="application/ld+json"]');
      if (!scriptElement || !dataLayer) return;
      
      try {
        const data = JSON.parse(scriptElement.textContent);
        if (!data) return;

        dataLayer.push({ ecommerce: null });  
        dataLayer.push(data);
      } catch (e) {
        console.error("[GTag] Error parsing intersection element data:", e);
      }
    }
  
    observeDOMChanges() {
      const domMutationObserver = new MutationObserver((mutationsList, observer) => {
        // For each mutation record, we look for added nodes
        for (const mutation of mutationsList) {
          if (mutation.addedNodes.length) {
            // If there are added nodes, we call domChanged to check for new items
            this.domChanged();
          }
        }
      });
  
      // Start observing the document body for added nodes and subtree modifications
      domMutationObserver.observe(document.body, {
        childList: true, // Observe direct children
        subtree: true, // and all descendants
        attributes: false // Set to true if you also want to observe attribute changes
      });
    }
    
    handleIntersection(entries) {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
              this.processIntersectionElement(entry.target);
              // Do not unobserve – keep observing so event re-fires when user scrolls back into view
          }
        });
    }
}

new gTagEvents();
